import { useState } from 'react';
import type { Role } from '../types/role.types';

interface RoleModalState {
  role: Role | null;
}

export function useRoleActionModals() {
  const [modalState, setModalState] = useState<RoleModalState | null>(null);
  const [roleToDelete, setRoleToDelete] = useState<Role | null>(null);

  return {
    modalState,
    roleToDelete,
    openCreateModal: () => setModalState({ role: null }),
    openEditModal: (role: Role) => setModalState({ role }),
    closeModal: () => setModalState(null),
    openDeleteModal: setRoleToDelete,
    closeDeleteModal: () => setRoleToDelete(null),
  };
}
